export default {
  init() {
    // JavaScript to be fired on all pages
    this.toggleSubMenu()
    this.desktopSearch()
    this.mobileSearch()
    this.openMobileMenu()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  toggleSubMenu() {
    // $('.header-bottom li.menu-item-has-children > a').on('click', function(e) {
    //   if ($(window).width() < 992) {
    //     e.preventDefault()
    //   }
    //   console.log('trigger once')
    //   const opened =  $(this).hasClass('open')
    //   const menuItem = $(this).parent('li.menu-item-has-children')

    //   if (opened) {
    //     console.log('close')
    //     $(this).removeClass('open')
    //     if ($(window).width() > 992) {
    //       $('.header-bottom').removeClass('menu-is-open')
    //     }
    //     menuItem.removeClass('open')
    //     menuItem.parents('.nav-primary').removeClass('open')
    //     menuItem.siblings().removeClass('open')
    //     menuItem.siblings().find('a').removeClass('open')
    //   } else {
    //     console.log('open')
    //     $(this).addClass('open')
    //     if ($(window).width() > 992) {
    //       $('.header-bottom').addClass('menu-is-open')
    //     }
    //     menuItem.addClass('open')
    //     menuItem.parents('.nav-primary').addClass('open')
    //     menuItem.siblings().removeClass('open')
    //     menuItem.siblings().find('a').removeClass('open')
    //   }
    // })

    $('.header-bottom li.menu-item-has-children').on('click', function(e) {
      const opened =  $(this).children('a').hasClass('open')
      const menuItem = $(this)
      const subMenu = $(this).children('.sub-menu-wrapper')
      if (subMenu.is(e.target) || subMenu.has(e.target).length) {
        return
      }

      if (opened) {
        $(this).children('a').removeClass('open')
        if ($(window).width() > 992) {
          $('.header-bottom').removeClass('menu-is-open')
          $('.header-bottom li.menu-item-has-children').removeClass('open')
          $('.header-bottom li.menu-item-has-children a').children('a').removeClass('open')
          console.log('test')
        }
        menuItem.removeClass('open')
        menuItem.parents('.nav-primary').removeClass('open')
        menuItem.siblings().removeClass('open')
        menuItem.siblings().find('a').removeClass('open')
      } else {
        $(this).children('a').addClass('open')
        if ($(window).width() > 992) {
          $('.header-bottom').addClass('menu-is-open')
        }
        menuItem.addClass('open')
        menuItem.parents('.nav-primary').addClass('open')
        menuItem.siblings().removeClass('open')
        menuItem.siblings().find('a').removeClass('open')
      }
    })
    $('.header-bottom li.menu-item-has-children > a').hover(function() {
      const menuItem = $(this).parent('li.menu-item-has-children')
      $(this).addClass('open')
      if ($(window).width() > 992) {
        $('.header-bottom').addClass('menu-is-open')
      }
      menuItem.addClass('open')
      menuItem.parents('.nav-primary').addClass('open')
      menuItem.siblings().removeClass('open')
      menuItem.siblings().find('a').removeClass('open')
    }, function() {
      const $this = $('.header-bottom li.menu-item-has-children > a')
      const menuItem = $('li.menu-item-has-children')
      // const menuItem = $(this).parent('li.menu-item-has-children')
      // console.log('a')
      if ($('.header-bottom:hover').length == 0) {
        $this.removeClass('open')
        if ($(window).width() > 992) {
          $('.header-bottom').removeClass('menu-is-open')
        }
        menuItem.removeClass('open')
        menuItem.parents('.nav-primary').removeClass('open')
        menuItem.siblings().removeClass('open')
        menuItem.siblings().find('a').removeClass('open')
      }
    })
    $('.header-bottom').hover(
      function() {
      }, function() {
      const $this = $('.header-bottom li.menu-item-has-children > a')
      const menuItem = $('li.menu-item-has-children')
      if ($('.header-bottom:hover').length == 0) {
        $this.removeClass('open')
        if ($(window).width() > 992) {
          $('.header-bottom').removeClass('menu-is-open')
        }
        menuItem.removeClass('open')
        menuItem.parents('.nav-primary').removeClass('open')
        menuItem.siblings().removeClass('open')
        menuItem.siblings().find('a').removeClass('open')
      }
      }
    );
  },
  desktopSearch() {
    $('.open-search').on('click', function() {
      $('.search-container').toggleClass('open')
      $('.primary-footer').toggleClass('open')
      $('#desktop-navigation').toggleClass('search-open')
    })
    $('.close-search').on('click', function() {
      $('.search-container').toggleClass('open')
      $('.primary-footer').toggleClass('open')
      $('#desktop-navigation').toggleClass('search-open')
    })
  },
  mobileSearch() {
    $('.open-search-mobile').on('click', function() {
      $('#mobile-navigation').removeClass('open')
      $('.hamburger').removeClass('is-active')
      $('.search-container-mobile').toggleClass('open')
    })
  },
  openMobileMenu() {
    var mobileMenu = $('#mobile-navigation');
    var hamburger = $('.hamburger')
    hamburger.on('click', function(e) {
      e.preventDefault();
      mobileMenu.toggleClass('open')
      hamburger.toggleClass('is-active')
    })

    // if (mobileNav.style.display === "block") {
    //   mobileNav.style.display = "none";
    //   hamburger[0].classList.remove("is-active");
    // } else {
    //   mobileNav.style.display = "block";
    //   hamburger[0].classList.add("is-active");
    // }
  },
};



// WEBPACK FOOTER //
// ./scripts/layouts/header.js